/**
 * Sprint Redesign v1 · Phase 2+ · Baustein 6 (Do 03.09.2026, 19:00).
 *
 * Zentrale Marken-Icons für Hund/Katze/Biene/Eule.
 * Ersetzt Emoji-Glyphs (🐕 🐈 🐝 🦉) durch Andreas' offizielle F4S-Icons.
 *
 * Nutzung:
 *   import { FokustypIcon } from "@/components/redesign/FokustypIcon";
 *   <FokustypIcon slug="eule" size={40} />
 */
import React from "react";
import hundSrc from "@/assets/fokustypen/hund.png";
import katzeSrc from "@/assets/fokustypen/katze.png";
import bieneSrc from "@/assets/fokustypen/biene.png";
import euleSrc from "@/assets/fokustypen/eule.png";

const SRC_MAP = {
  hund: hundSrc,
  katze: katzeSrc,
  biene: bieneSrc,
  eule: euleSrc,
};

const NAME_MAP = { hund: "Hund", katze: "Katze", biene: "Biene", eule: "Eule" };

export function FokustypIcon({ slug, size = 40, className = "" }) {
  const key = String(slug || "").toLowerCase();
  const src = SRC_MAP[key];
  if (!src) return null;
  return (
    <img
      src={src}
      alt={`${NAME_MAP[key]}-Symbol`}
      data-testid={`fokustyp-icon-${key}`}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={["object-contain", className].join(" ")}
      loading="lazy"
    />
  );
}

export default FokustypIcon;
